<div>
  <ng-content />
</div>
